<div>
  <ng-content />
</div>
